import { type LucideIcon } from "lucide-react";

import { cn } from "@/lib/utils";

type ChipProps = {
  color: "blue" | "green" | "orange" | "red" | "purple" | "gray";
  children: React.ReactNode;
  icon?: LucideIcon;
  className?: string;
};

export function Chip({ color, children, icon: Icon, className }: ChipProps) {
  let colorClass = "";

  switch (color) {
    case "blue":
      colorClass = "bg-info-100 text-info-700";
      break;
    case "green":
      colorClass = "bg-success-100 text-success-700";
      break;
    case "orange":
      colorClass = "bg-warning-100 text-warning-700";
      break;
    case "red":
      colorClass = "bg-error-100 text-error-700";
      break;
    case "purple":
      colorClass = "bg-primary-50 text-primary-500";
      break;
    case "gray":
      colorClass = "bg-neutral-200 text-neutral-600";
      break;
    default:
      colorClass = "";
  }

  return (
    <span
      className={cn(
        "inline-flex h-5 shrink-0 items-center gap-1 rounded-full px-2 text-sm",
        colorClass,
        className
      )}
    >
      {Icon && <Icon className="h-3 w-3" aria-hidden="true" />} {/* 아이콘 */}
      {children}
    </span>
  );
}
